var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1d66c2;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    className: "cls-1",
    cx: 107.5,
    cy: 107.5,
    r: 107.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn-2",
    "data-name": "LinkedIn"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "LinkedIn-3",
    "data-name": "LinkedIn",
    className: "cls-2",
    x: 62.67,
    y: 85.11,
    width: 20.74,
    height: 66.89
  }), /*#__PURE__*/React.createElement("path", {
    id: "LinkedIn-4",
    "data-name": "LinkedIn",
    className: "cls-2",
    d: "M1521.25,637.77c-8-.67-15.38,4-19.4,10.71v-9.37h-20.06V706h20.73V672.56c0-8.7,2-17.4,12.71-17.4s10.7,10,10.7,18.06V706h20.74l-.67-36.12C1546,651.82,1542.65,637.77,1521.25,637.77Z",
    transform: "translate(-1385 -554)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "LinkedIn-5",
    "data-name": "LinkedIn",
    className: "cls-2",
    cx: 72.71,
    cy: 63.71,
    r: 12.04
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.6e198a4f1e036c15abe76a064383627c.svg";
export { ForwardRef as ReactComponent };